import radioConsentTranslation from './index.json';

export default radioConsentTranslation;
